export default {
  name: 'brandModel',
  data() {
    return {
      menuList: [],
      brandList: [],
      brandDis: false,
      classification: false,
      model: false,
      dialogClass: false,
      dialogModel: false,
      proForm: {
        brandSource: '1'
      },
      menuProps: {
        children: 'children',
        label: 'brandNameCh'
      },
      menuSeled: [],
      menuDefaultChecked: [],
      menuDefaultShow: [], // 默认展开层级
      menuDefaultShow2: [], // 默认展开获取父级删除后展开使用
      btnDisabled: true,
      brandForm: {
        brandSource: '',
        brandName: '',
        trademark: '',
        englishName: '',
        engTrademark: '',
        custTypeDesc: '',
        brandId: ''
      },
      addBrandForm: {
        brandSource: '',
        brandName: '',
        trademark: '',
        englishName: '',
        engTrademark: '',
        custTypeDesc: ''
      },
      classForm: {
        brandSource: '',
        brandName: '',
        brandId: '',
        categoryId: '',
        className: '',
        custTypeDesc: ''
      },
      addClassBrandForm: {
        brandSource: '',
        brandName: '',
        className: '',
        custTypeDesc: '',
        brandId: ''
      },
      modelForm: {
        brandSource: '',
        brandName: '',
        className: '',
        modelCode: '',
        modelName: '',
        modelId: '',
        custTypeDesc: '',
        brandId: '',
        categoryId: ''
      },
      addModelBrandForm: {
        brandSource: '',
        brandId: '',
        categoryId: '',
        brandName: '',
        className: '',
        modelCode: '',
        modelName: '',
        custTypeDesc: ''
      },
      custTypeDetail: {
        custTypeId: '',
        createTime: '',
        creator: '',
        custTypeCode: '',
        custTypeDesc: '',
        custTypeNameCn: '',
        custTypeNameEn: '',
        parentTypeCode: '',
        parentTypeName: ''
      },
      menuNode: {},
      userList: [],
      userNone: false,
      custForm: {
        custTypeNameCn: '',
        custTypeNameEn: '',
        custTypeDesc: ''
      },
      dialogTitle: {
        addSameOrg: '添加一级客户类型',
        addSubOrg: '添加子级客户类型'
      },
      dialogStatus: '',
      dialogFormVisible: false,
      addBrandRules: {
        brandSource: [
          { required: true, message: '请选择品牌来源', trigger: 'blur' }
        ],
        brandName: [
          { required: true, message: '请请输入品牌名称', trigger: 'blur' }
        ],
        englishName: [
          { message: '请填写英文名称', trigger: 'blur' },
          { validator: this.regular.englishName, trigger: ['blur', 'change'] }
        ],
        engTrademark: [
          { message: '请填写英文商标', trigger: 'blur' },
          { validator: this.regular.englishName, trigger: ['blur', 'change'] }
        ]
      },
      addClassRule: {
        brandSource: [
          { required: true, message: '请选择品牌来源', trigger: 'blur' }
        ],
        brandName: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' }
        ],
        className: [
          { required: true, message: '请输入品牌分类', trigger: 'blur' }
        ]
      },
      addModelBrandRule: {
        brandSource: [
          { required: true, message: '请选择品牌来源', trigger: 'blur' }
        ],
        brandName: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' }
        ],
        className: [
          { required: true, message: '请输入品牌分类', trigger: 'blur' }
        ],
        modelCode: [
          { required: true, message: '请输入型号编码', trigger: 'blur' }
        ],
        modelName: [
          { required: true, message: '请输入型号名称', trigger: 'blur' }
        ]
      },
      rules: {
        custTypeNameCn: [
          { required: true, message: '请填写客户类型名称', trigger: 'blur' }
        ],
        englishName: [
          { message: '请填写英文名称', trigger: 'blur' },
          { validator: this.regular.englishName, trigger: ['blur', 'change'] }
        ],
        engTrademark: [
          { message: '请填写英文商标', trigger: 'blur' },
          { validator: this.regular.englishName, trigger: ['blur', 'change'] }
        ],
        brandSource: [
          { required: true, message: '请选择品牌来源', trigger: 'blur' }
        ],
        brandName: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' }
        ],
        className: [
          { required: true, message: '请输入品牌分类', trigger: 'blur' }
        ],
        modelCode: [
          { required: true, message: '请输入型号编码', trigger: 'blur' }
        ],
        modelName: [
          { required: true, message: '请输入型号名称', trigger: 'blur' }
        ],
        custTypeNameEn: [
          { required: true, message: '请填写类型英文名称', trigger: 'blur' },
          { validator: this.regular.englishName, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created() {
    // this.queryMenuList()
    this.brandChange('1')
  },
  methods: {
    queryMenuList(val) {
      let _self = this
      let params = {}
      params.source = val
      this.$http
        .get(_self.$API.brand.queryBrandTreeBySource, { params: params })
        .then(function(r) {
          console.log(r)
          _self.menuList = r.data.resData
          if (_self.menuList.length) {
            for (let o of _self.menuList) {
              o.hierarchy = 'one' // 代表第一层级
              o.keyId = o.brandId
              if (o.children.length) {
                for (let p of o.children) {
                  p.hierarchy = 'two' // 代表第二层级
                  p.brandNameCh = p.categoryName
                  p.keyId = p.categoryId
                  if (p.children.length) {
                    for (let v of p.children) {
                      v.hierarchy = 'three' // 代表第三层级
                      v.brandNameCh = v.modelName
                      v.keyId = v.modelId
                    }
                  }
                }
              }
            }
            console.log(_self.menuDefaultShow)
            console.log(_self.menuSeled)
            if (!_self.menuDefaultShow.length) {
              // 请求详情
              _self.queryProdBrandByBrandId(_self.menuList[0].brandId)
            }
          } else {
            _self.menuSeled = []
          }
          // _self.custTypeDetail = r.data.resData
          // _self.custTypeDetail.custTypeId = params.custTypeId
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    queryProdBrandByBrandId (val) {
      let params = {}
      params.brandId = val
      let _this = this
      /* 查询品牌详情 */
      this.$http
        .get(_this.$API.brand.queryProdBrandByBrandId, { params: params })
        .then(function(r) {
          let data = r.data.resData
          _this.brandForm.brandSource = data.source + ''
          _this.brandForm.brandName = data.brandNameCh
          _this.brandForm.trademark = data.brandNumCh
          _this.brandForm.englishName = data.brandNameEn
          _this.brandForm.engTrademark = data.brandNumEn
          _this.brandForm.custTypeDesc = data.description
          _this.brandForm.brandId = data.brandId
          _this.brandDis = true
          // _self.custTypeDetail.custTypeId = params.custTypeId
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    queryProdCategoryByCateId (val) {
      let params = {}
      params.categoryId = val
      let _this = this
      /* 查询品牌详情 */
      this.$http
        .get(_this.$API.brand.queryProdCategoryByCateId, { params: params })
        .then(function(r) {
          let data = r.data.resData
          console.log(data)
          _this.classForm.brandSource = data.source + ''
          _this.classForm.brandName = data.brandNameCh
          _this.classForm.categoryId = data.categoryId
          _this.classForm.className = data.categoryName
          _this.classForm.custTypeDesc = data.description
          _this.classForm.brandId = data.brandId
          // _self.custTypeDetail.custTypeId = params.custTypeId
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    queryProdModelByModelId (val) {
      let params = {}
      params.modelId = val
      let _this = this
      /* 查询品牌详情 */
      this.$http
        .get(_this.$API.brand.queryProdModelByModelId, { params: params })
        .then(function(r) {
          let data = r.data.resData
          console.log(data)
          _this.modelForm.brandSource = data.source + ''
          _this.modelForm.brandName = data.brandNameCh
          _this.modelForm.categoryId = data.categoryId
          _this.modelForm.className = data.categoryName
          _this.modelForm.modelCode = data.modelCode
          _this.modelForm.modelName = data.modelName
          // _this.modelForm.custTypeDesc = data.description
          _this.modelForm.brandId = data.brandId
          _this.modelForm.modelId = data.modelId
          // _self.custTypeDetail.custTypeId = params.custTypeId
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    menuNodeClick(item, data) {
      this.menuDefaultShow = []
      this.menuSeled = []
      this.menuSeled.push(item)
      this.menuDefaultShow.push(item.keyId)
      console.log(item)
      if (item.hierarchy && item.hierarchy === 'one') {
        this.brandDis = true
        this.classification = false
        this.model = false
        this.queryProdBrandByBrandId(item.brandId)
      } else if (item.hierarchy && item.hierarchy === 'two') {
        this.brandDis = false
        this.classification = true
        this.model = false
        this.queryProdCategoryByCateId(item.categoryId)
      } else if (item.hierarchy && item.hierarchy === 'three') {
        this.brandDis = false
        this.classification = false
        this.model = true
        this.queryProdModelByModelId(item.modelId)
      }
    },
    brandChange (val) {
      this.menuSeled = []
      this.menuDefaultShow = []
      this.queryMenuList(val)
      // let params = {}
      // params.source = val
      // let _self = this
      // this.$http
      //   .get('http://172.16.9.132:5010/agw/brandCtr/queryBrandTreeBySource', { params: params })
      //   .then(function(r) {
      //     console.log(r)
      //     _self.menuList = r.data.resData
      //     if (_self.menuList.length) {
      //       for (let o of _self.menuList) {
      //         o.hierarchy = 'one' // 代表第一层级
      //         o.keyId = o.brandId
      //         if (o.children.length) {
      //           for (let p of o.children) {
      //             p.hierarchy = 'two' // 代表第二层级
      //             p.brandNameCh = p.categoryName
      //             p.keyId = p.categoryId
      //             if (p.children.length) {
      //               for (let v of p.children) {
      //                 v.hierarchy = 'three' // 代表第三层级
      //                 v.brandNameCh = v.modelName
      //                 v.keyId = v.modelId
      //               }
      //             }
      //           }
      //         }
      //       }
      //       console.log(_self.menuDefaultShow)
      //       // 请求详情
      //       _self.queryProdBrandByBrandId(_self.menuList[0].brandId)
      //     } else {
      //       _self.menuSeled = []
      //     }
      //     // _self.custTypeDetail = r.data.resData
      //     // _self.custTypeDetail.custTypeId = params.custTypeId
      //   })
      //   .catch(function(error) {
      //     console.log(error)
      //   })
    },
    /* 保存客户类型详情 */
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.custTypeDetail.custTypeId) {
            let _self = this
            let params = {
              custTypeId: this.custTypeDetail.custTypeId,
              custTypeDesc: this.custTypeDetail.custTypeDesc,
              custTypeNameCn: this.custTypeDetail.custTypeNameCn,
              custTypeNameEn: this.custTypeDetail.custTypeNameEn
            }
            /* 保存编辑组织信息 */
            this.$http
              .post(this.$API.customerManagement.editCustType2, params)
              .then(function(r) {
                _self.$message({
                  message: '保存成功',
                  type: 'success'
                })
                _self.queryMenuList()
              })
              .catch(function(error) {})
          } else {
            return false
          }
        }
      })
    },
    closeDialog(formName) {
      this.dialogFormVisible = false
      this.addBrandForm = {
        brandSource: '',
        brandName: '',
        trademark: '',
        englishName: '',
        engTrademark: '',
        custTypeDesc: ''
      }
      this.$refs[formName].resetFields()
    },
    closeClassBrand(formName) {
      this.dialogClass = false
      this.addClassBrandForm = {
        brandSource: '',
        brandName: '',
        className: '',
        custTypeDesc: '',
        brandId: ''
      }
      this.$refs[formName].resetFields()
    },
    closeAddModel(formName) {
      this.dialogModel = false
      this.addModelBrandForm = {
        brandSource: '',
        brandId: '',
        categoryId: '',
        brandName: '',
        className: '',
        modelCode: '',
        modelName: '',
        custTypeDesc: ''
      }
      this.$refs[formName].resetFields()
    },
    saveAddBrandForm (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.source = _this.addBrandForm.brandSource
          op.brandNameCh = _this.addBrandForm.brandName
          op.brandNameEn = _this.addBrandForm.englishName
          op.brandNumCh = _this.addBrandForm.trademark
          op.brandNumEn = _this.addBrandForm.engTrademark
          op.description = _this.addBrandForm.custTypeDesc
          _this.$axios({
            url: _this.$API.brand.addHardProdBrand,
            // url: 'http://172.16.9.132:5010/agw/brandCtr/addHardProdBrand',
            method: 'post',
            data: op
          }).then((response) => {
            if (_this.proForm.brandSource) {
              _this.queryMenuList(_this.proForm.brandSource)
            }
            _this.$message.success('品牌信息添加成功!')
            _this.dialogFormVisible = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveBrandForm (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.source = _this.brandForm.brandSource
          op.brandNameCh = _this.brandForm.brandName
          op.brandNameEn = _this.brandForm.englishName
          op.brandNumCh = _this.brandForm.trademark
          op.brandNumEn = _this.brandForm.engTrademark
          op.description = _this.brandForm.custTypeDesc
          op.brandId = _this.brandForm.brandId
          _this.$axios({
            // url: _this.$API.accountManagement.supAccountRecharge,
            url: _this.$API.brand.editHardProdBrand,
            method: 'post',
            data: op
          }).then((response) => {
            if (_this.proForm.brandSource) {
              _this.queryMenuList(_this.proForm.brandSource)
            }
            _this.$message.success('品牌信息编辑成功!')
            _this.dialogFormVisible = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveClassBrandForm (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.source = _this.addClassBrandForm.brandSource
          op.brandId = _this.addClassBrandForm.brandId
          op.categoryName = _this.addClassBrandForm.className
          op.description = _this.addClassBrandForm.custTypeDesc
          _this.$axios({
            // url: _this.$API.accountManagement.supAccountRecharge,
            url: _this.$API.brand.addProdCategory,
            method: 'post',
            data: op
          }).then((response) => {
            if (_this.proForm.brandSource) {
              _this.queryMenuList(_this.proForm.brandSource)
            }
            _this.$message.success('品牌分类添加成功!')
            _this.dialogClass = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveClassForm (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.source = _this.classForm.brandSource
          op.brandId = _this.classForm.brandId
          op.categoryId = _this.classForm.categoryId
          op.categoryName = _this.classForm.className
          op.description = _this.classForm.custTypeDesc
          _this.$axios({
            // url: _this.$API.accountManagement.supAccountRecharge,
            url: _this.$API.brand.editProdCategory,
            method: 'post',
            data: op
          }).then((response) => {
            if (_this.proForm.brandSource) {
              _this.queryMenuList(_this.proForm.brandSource)
            }
            _this.$message.success('品牌分类编辑成功!')
            _this.dialogClass = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveModelBrandForm (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.source = _this.addModelBrandForm.brandSource
          op.brandId = _this.addModelBrandForm.brandId
          op.categoryId = _this.addModelBrandForm.categoryId
          op.modelCode = _this.addModelBrandForm.modelCode
          op.modelName = _this.addModelBrandForm.modelName
          op.modelCode = _this.addModelBrandForm.modelCode
          op.description = _this.addModelBrandForm.custTypeDesc
          _this.$axios({
            // url: _this.$API.accountManagement.supAccountRecharge,
            url: _this.$API.brand.addProdModel,
            method: 'post',
            data: op
          }).then((response) => {
            if (_this.proForm.brandSource) {
              _this.queryMenuList(_this.proForm.brandSource)
            }
            _this.$message.success('品牌型号添加成功!')
            _this.dialogModel = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveModelForm (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.source = _this.modelForm.brandSource
          op.brandId = _this.modelForm.brandId
          op.modelId = _this.modelForm.modelId
          op.categoryId = _this.modelForm.categoryId
          op.modelCode = _this.modelForm.modelCode
          op.modelName = _this.modelForm.modelName
          // op.description = _this.modelForm.custTypeDesc
          _this.$axios({
            // url: _this.$API.accountManagement.supAccountRecharge,
            url: _this.$API.brand.editProdModel,
            method: 'post',
            data: op
          }).then((response) => {
            if (_this.proForm.brandSource) {
              _this.queryMenuList(_this.proForm.brandSource)
            }
            _this.$message.success('品牌型号编辑成功!')
            _this.dialogModel = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    addSameOrg () {
      this.dialogFormVisible = true
    },
    addSubOrg(node, data) {
      console.log(data)
      console.log(node)
      if (data.hierarchy === 'one') {
        this.addClassBrandForm.brandSource = this.proForm.brandSource
        this.addClassBrandForm.brandName = data.brandNameCh
        this.addClassBrandForm.brandId = data.brandId
        this.dialogClass = true
      }
      if (data.hierarchy === 'two') {
        if (node.parent.data) {
          this.addModelBrandForm.brandId = node.parent.data.brandId
          this.addModelBrandForm.brandName = node.parent.data.brandNameCh
        }
        this.addModelBrandForm.brandSource = this.proForm.brandSource
        this.addModelBrandForm.className = data.categoryName
        this.addModelBrandForm.categoryId = data.categoryId
        this.dialogModel = true
      }
    },
    delOrg(node, data) {
      this.$confirm('确认删除？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          /* 获取父级id作为默认展开层级 */
          console.log(data)
          let _self = this
          if (data.hierarchy === 'three') {
            this.$http
            .post(_self.$API.brand.delProdModel, {
              modelId: data.modelId
            })
            .then(function(r) {
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryMenuList(_self.proForm.brandSource)
            })
            .catch(function(error) {
              console.log(error)
            })
          } else if (data.hierarchy === 'two') {
            this.$http
            .post(_self.$API.brand.delProdCategory, {
              categoryId: data.categoryId
            })
            .then(function(r) {
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryMenuList(_self.proForm.brandSource)
            })
            .catch(function(error) {
              console.log(error)
            })
          } else if (data.hierarchy === 'one') {
            this.$http
            .post(_self.$API.brand.delHardProdBrand, {
              brandId: data.brandId
            })
            .then(function(r) {
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryMenuList(_self.proForm.brandSource)
            })
            .catch(function(error) {
              console.log(error)
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/brandManagement/brandModel.js